<template>
  <div id="footer">Copyright © 2022 Thermaltake Technology Co., Ltd. All Rights Reserved.</div>
</template>